export function FlagIcon(props) {
  return (
    <svg
      viewBox="0 0 17 22"
      width="17"
      height="22"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.25 0a.45.45 0 01.45.45V1.8h11.594a1.35 1.35 0 011.208 1.954L13.553 7.65l1.949 3.896a1.35 1.35 0 01-1.208 1.954H2.7v6.3h1.35a.45.45 0 010 .9H.45a.45.45 0 010-.9H1.8V.45A.45.45 0 012.25 0zm.45 12.6h11.594a.45.45 0 00.402-.652l-2.15-4.298 2.15-4.298a.45.45 0 00-.402-.652H2.7v9.9z"
        transform="translate(-960 -278) translate(960.971 274.316) translate(0 4.05)"
        fill="#293644"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  );
}

export function ClockIcon(props) {
  return (
    <svg
      viewBox="0 0 22 21"
      width="22"
      height="21"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M.91 9.9h1.34a.45.45 0 110 .9H.91a9.45 9.45 0 008.99 8.99v-1.34a.45.45 0 01.9 0v1.34a9.451 9.451 0 008.99-8.99h-1.34a.45.45 0 010-.9h1.34A9.451 9.451 0 0010.8.91v1.34a.45.45 0 11-.9 0V.91A9.45 9.45 0 00.91 9.9m-.91.45C0 4.633 4.634 0 10.35 0 16.067 0 20.7 4.633 20.7 10.35S16.067 20.7 10.35 20.7C4.634 20.7 0 16.067 0 10.35M10.35 5.4c.25 0 .45.202.45.45v4.284l4.332 3.464a.451.451 0 01-.563.704l-4.5-3.6a.45.45 0 01-.169-.352v-4.5a.45.45 0 01.45-.45"
        transform="translate(-957 -327) translate(957.967 324.066) translate(0 3.15)"
        fill="#293644"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  );
}

export function CoinsIcon(props) {
  return (
    <svg
      viewBox="0 0 20 20"
      width="20"
      height="20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.19 2.145C.973 2.358.9 2.546.9 2.7c0 .154.073.341.29.554.219.216.559.432 1.014.621.91.38 2.199.625 3.646.625 1.446 0 2.735-.246 3.646-.625.454-.19.795-.405 1.013-.62.218-.214.291-.401.291-.555 0-.154-.073-.342-.29-.555-.22-.216-.56-.431-1.014-.62C8.586 1.145 7.296.9 5.85.9c-1.447 0-2.735.245-3.646.625-.455.189-.796.404-1.014.62zm9.61 2.038c-.275.2-.6.374-.96.523-1.043.436-2.455.694-3.99.694-1.536 0-2.947-.258-3.992-.694A4.759 4.759 0 01.9 4.183V6.3c0 .154.073.341.29.554.219.216.559.431 1.014.621.91.38 2.199.625 3.646.625 1.446 0 2.735-.246 3.646-.625.454-.19.795-.405 1.013-.62.218-.214.291-.401.291-.555V4.183zm0 3.6c-.275.2-.6.374-.96.523C8.798 8.742 7.386 9 5.85 9c-1.536 0-2.947-.258-3.992-.694A4.759 4.759 0 01.9 7.783V9.9c0 .154.073.341.29.554.219.216.559.431 1.014.621.91.38 2.199.625 3.646.625.616 0 1.206-.045 1.75-.126.315-.376.784-.683 1.329-.925a8.38 8.38 0 011.871-.554V7.783zm.9 2.185V2.7c0-.468-.23-.872-.559-1.196-.328-.323-.78-.593-1.3-.811C8.797.258 7.385 0 5.85 0 4.314 0 2.903.258 1.858.693c-.52.218-.972.488-1.3.81C.23 1.829 0 2.233 0 2.7v10.8c0 .467.23.871.559 1.196.327.323.778.592 1.299.81 1.044.436 2.456.694 3.992.694.464 0 .916-.024 1.35-.068v.068c0 .467.23.871.559 1.196.327.323.778.592 1.299.81 1.044.436 2.456.694 3.992.694 1.535 0 2.947-.258 3.99-.694.522-.218.974-.487 1.301-.81.33-.325.559-.729.559-1.196v-3.6c0-.468-.23-.872-.559-1.196-.328-.323-.78-.593-1.3-.811-1.044-.435-2.456-.693-3.991-.693-.465 0-.917.023-1.35.068zm6.3 4.115V16.2c0 .154-.073.341-.29.554-.22.216-.56.431-1.014.621-.91.38-2.2.625-3.646.625-1.447 0-2.735-.246-3.646-.625-.455-.19-.796-.405-1.014-.62-.217-.214-.29-.401-.29-.555v-2.117c.274.2.6.374.958.523 1.044.436 2.456.694 3.992.694 1.535 0 2.947-.258 3.99-.694.36-.15.685-.324.96-.523zM8.1 12.6c0 .154.073.341.29.554.218.216.559.431 1.014.621.91.38 2.199.625 3.646.625 1.446 0 2.735-.246 3.646-.625.454-.19.795-.405 1.013-.62.218-.214.291-.401.291-.555 0-.154-.073-.342-.29-.555-.22-.216-.56-.431-1.014-.62-.91-.38-2.2-.625-3.646-.625-.61 0-1.193.043-1.735.122-.791.117-1.482.31-2.022.55-.548.243-.9.517-1.07.77a.642.642 0 00-.123.358zm-.9 2.626V12.6c0-.023 0-.046.002-.068-.435.044-.888.068-1.352.068-1.536 0-2.947-.258-3.992-.694a4.759 4.759 0 01-.958-.523V13.5c0 .154.073.341.29.554.219.216.559.431 1.014.621.91.38 2.199.625 3.646.625.467 0 .92-.026 1.35-.074z"
        transform="translate(-959 -378) translate(959.317 373.366) translate(0 5.4)"
        fill="#293644"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  );
}

export function GraphIcon(props) {
  return (
    <svg
      width="2.2rem"
      height="1.7rem"
      viewBox="0 0 22 17"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M.45 8.1a.45.45 0 01.45.45v12.6c0 .746.605 1.35 1.35 1.35h18a.45.45 0 010 .9h-18A2.25 2.25 0 010 21.15V8.55a.45.45 0 01.45-.45m15.75.45a.45.45 0 01.45-.45h3.6a.45.45 0 01.45.45v3.6a.45.45 0 01-.9 0V9.636l-5.795 5.795a1.35 1.35 0 01-1.91 0L9.77 13.105a.45.45 0 00-.638 0L4.37 17.869a.451.451 0 01-.638-.638l4.764-4.762a1.35 1.35 0 011.91 0l2.326 2.326a.45.45 0 00.638 0L19.164 9H16.65a.45.45 0 01-.45-.45"
        transform="translate(-959 -430) translate(959.644 422.666)"
        fill="#293644"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  );
}

export function AlertIcon(props) {
  return (
    <svg
      width="11.3rem"
      height="9.9rem"
      viewBox="0 0 113 99"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M515.838 260.724c-2.976-4.978-10.153-4.978-13.129 0l-43.222 72.362c-3.063 5.128.612 11.65 6.564 11.65h86.445c5.952 0 9.622-6.522 6.564-11.65l-43.222-72.362zm-17.508-2.635c4.956-8.301 16.93-8.301 21.882 0l43.222 72.362c5.105 8.542-1.02 19.412-10.938 19.412h-86.445c-9.918 0-16.043-10.87-10.938-19.412l43.217-72.362zm10.944 25.119a2.556 2.556 0 012.552 2.563v20.51a2.559 2.559 0 01-2.552 2.563 2.559 2.559 0 01-2.553-2.563v-20.51a2.556 2.556 0 012.553-2.563zm0 35.891a2.556 2.556 0 012.552 2.564v5.127a2.559 2.559 0 01-2.552 2.564 2.559 2.559 0 01-2.553-2.564v-5.127a2.556 2.556 0 012.553-2.564z"
        transform="translate(-453 -251)"
        fill="#E41F1F"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  );
}
